import { msgTypes } from "constants/msgTypes";
import { RouteType } from "constants/RouteType";
import { AuthService } from "services/auth/AuthService";
import { UploadFileService } from "./UploadFileService";
import { MembershipModel } from "model/screensModels/membership/MembershipModel";
import { RequestModel } from "model/utilModels/RequestModel";
import { MemberLoginService } from "services/menu/dashboard/MemberLoginService";
import { LocalStorageService } from "services/auth/LocalStorageService";
import { ResponseModel } from "model/utilModels/ResponseModel";



export class UtilService {
    // constructor() { }

    //load country
    static getCountryList = async () => {
        const url = RouteType.GET_COUNTRY;
        const response = AuthService.postCryptoRequest(url, msgTypes.EMPTY_STR);
        return response;
    };

    //load State List
    static getStateList = async (countryId: string | object) => {
        const url = RouteType.GET_STATE;
        const response = AuthService.postCryptoRequest(url, JSON.stringify(countryId));
        return response;
    };

    //load State List
    static getCityList = async (stateId: string | object) => {
        const url = RouteType.GET_CITY;
        const response = AuthService.postCryptoRequest(url, JSON.stringify(stateId));
        return response;
    };


    //load State List
    static getCompanyList = async () => {
        const url = RouteType.ADMIN + RouteType.COMPANY_LIST;
        const response =await AuthService.postCryptoRequest(url, JSON.stringify(msgTypes.EMPTY_STR));
        return response;
    };

    // Load Contact Person By Company Id
    static getContactPersonsByCompanyId = async (companyId: string) => {
        const url = RouteType.ADMIN + RouteType.COMPANY_LIST_BY_ID;
        const data = { "companyId": companyId };
        const response = AuthService.postCryptoRequest(url, JSON.stringify(data));
        return response;
    }

    static getImagePath = async (image: any) => {
        if (image) {
            const formData = new FormData();
            formData.append("file", image);
            const imageurlData = await UploadFileService.getImagePath(formData);
            return await imageurlData.data.fileName;
        } else {
            return '';
        }
    }

    static getCompanyDetailsByCompanyId = async (requestData: MembershipModel) => {
        const url = RouteType.ADMIN + RouteType.COMPANY_LIST_BY_ID;
        const response = AuthService.postCryptoRequest(url, JSON.stringify(requestData));
        return response;
    }

    static getBranchesByCompanyId = async (requestData: MembershipModel) => {
        const url = RouteType.ADMIN + RouteType.GET_BRANCHES_BY_COMPANY_ID;
        const response = AuthService.postCryptoRequest(url, JSON.stringify(requestData));
        return response;
    }

    

    static getCompanyDetailsByCompanyIdrequest = async (requestData: RequestModel) => {
        const url = RouteType.ADMIN + RouteType.COMPANY_LIST_BY_ID;
        const response = AuthService.postCryptoRequest(url, JSON.stringify(requestData));
        return response;
    }

    // Save Visitor Details
    static visitorRequestData = async (companyId) => {
        const data = new RequestModel();
        data.companyId = companyId;
        const userDetails = JSON.parse(await LocalStorageService.getUserDetails());
    
        const compnayRepresentative = userDetails.contactPerson.find(
          (person) => person.contactIsrepresentative === true
        );
        data.visitorProfileId = "";
        data.visitorId = compnayRepresentative.contactPersonId;
        const res = await MemberLoginService.getLoginDetails();
        const loginDetails = res?.data[0].loginDetails[res.data.length - 1];
        data.latitude = loginDetails.latitude;
        data.longitude = loginDetails.longitude;
        data.countryId = userDetails.countryId;
        return data;
    };
    

    static saveVisitorDetails = async (companyId) => {
        const requestData = await UtilService.visitorRequestData(companyId);

        const url = RouteType.ADMIN + RouteType.VISITED_PROFILE + RouteType.STORE;
        let response = new ResponseModel();
        if(requestData.latitude!==null && requestData.longitude!==null){
            response = await AuthService.postCryptoRequest(url, JSON.stringify(requestData));
        }
        return response;
    }

    //get fixed company service List
    static getFixedCompanyServiceList = async () => {
        const url = RouteType.ADMIN + RouteType.FIXED_COMPANY_SERVICES;
        const response = AuthService.postCryptoRequest(url, msgTypes.EMPTY_STR);
        return response;
    }

    //get Currency List
    static getCurrencyList = async () => {
        const url = RouteType.GET_CURRENCY;
        const response = await AuthService.postCryptoRequest(url, msgTypes.EMPTY_STR);
        // const updatedData = await response.data.map(data=>{
        //     data.currency = data.currencySymbol + "(" + data.country + ")"
        // })
        // response.data = updatedData;
        return response;
        
    }

    //Begin:: Change case
    static sentenceCase = (str) => {
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();

        return str.replace(/\w\S*/g,
            function (txt) {
                return txt.charAt(0).toUpperCase() +
                    txt.substr(1).toLowerCase();
            });
    }

    static upperCase = (str) => {
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();

        return str.replace(/\w\S*/g,
            function (txt) {
                return txt.toUpperCase();
            });
    }

    static lowerCase = (str) => {
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();

        return str.replace(/\w\S*/g,
            function (txt) {
                return txt.toLowerCase();
            });
    }

    //End:: change Case
}